var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
        [
          _c("Header", { attrs: { title: "Video Test" } }),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "pa-0",
                  attrs: { id: "main_content_minwidthset", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0", attrs: { align: "start" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-10",
                          attrs: { id: "main_content", cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "start", justify: "center" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0",
                                  attrs: {
                                    id: "video_box",
                                    cols: "8",
                                    align: "center",
                                  },
                                },
                                [
                                  _c("video", {
                                    staticClass:
                                      "video-js vjs-default-skin vjs-big-play-centered vjs-current-time vjs-control-bar",
                                    staticStyle: {
                                      "object-fit": "fill",
                                      width: "100%",
                                      height: "100%",
                                      cursor: "default",
                                    },
                                    attrs: {
                                      id: "video1",
                                      height: "500",
                                      crossorigin: "anonymous",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      attrs: { id: "zoom_change" },
                                      on: {
                                        mouseover: function ($event) {
                                          return _vm.hoverZoom()
                                        },
                                        mouseout: function ($event) {
                                          return _vm.hoverOutZoom()
                                        },
                                      },
                                    },
                                    [
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          "max-height": "1.5rem",
                                          "max-width": "1.5rem",
                                          src: require("@/assets/images/zoom_minus.png"),
                                        },
                                      }),
                                      _c("v-slider", {
                                        staticClass: "zoom_control",
                                        attrs: {
                                          min: "10",
                                          max: "40",
                                          step: "1",
                                          dense: "",
                                          "hide-details": "",
                                          color: "grey",
                                          "track-color": "grey",
                                          "thumb-color": "white",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.setZoomScaleText(
                                              _vm.zoomScale
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.zoomScale,
                                          callback: function ($$v) {
                                            _vm.zoomScale = $$v
                                          },
                                          expression: "zoomScale",
                                        },
                                      }),
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          "max-height": "1.5rem",
                                          "max-width": "1.5rem",
                                          src: require("@/assets/images/zoom_plus.png"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }